export default "__VITE_ASSET__CvA$Al3u__"